// Mock data for FIT-FRAME website

export const heroData = {
  backgroundImage: "https://i.ibb.co/sv3FHsgy/jeet-click-0042.jpg",
  alternateImage: "https://i.ibb.co/kgZGddf0/DSC0047-Edit.png",
  stats: [
    { label: "Gym Partners", value: "10+" },
    { label: "Member Reach", value: "8,500+" },
    { label: "Gym-Specific Content", value: "100%" }
  ]
};

export const servicesData = [
  {
    id: 1,
    title: "Cinematic Reels",
    description: "Cinematic short videos of your vibe, workout form, and fitness journey — made for Instagram and YouTube Shorts."
  },
  {
    id: 2,
    title: "Professional Photos",
    description: "High-quality gym photoshoots — lifting shots, physique photos, and lifestyle images that make your profile stand out."
  },
  {
    id: 3,
    title: "Transformation Package",
    description: "A full story-based guided shoot — your complete fitness journey captured in one premium session, from start to highlight reel."
  },
  {
    id: 4,
    title: "Gym Brand Content",
    description: "We also help gyms build their brand — reels, posts, and review videos that attract new members and elevate the gym's image."
  }
];

export const processSteps = [
  {
    step: "01",
    title: "Choose Your Package",
    description: "Pick a plan that fits your goal — from a quick reel to the full transformation story package."
  },
  {
    step: "02",
    title: "Book Your Shoot Day",
    description: "We come directly to your gym. No travel needed — we shoot in your real training environment."
  },
  {
    step: "03",
    title: "We Create & Edit",
    description: "Our team handles everything — lighting, angles, direction, and professional post-production editing."
  },
  {
    step: "04",
    title: "You Shine Online",
    description: "Receive your polished reels and photos, ready to post, share, and show your transformation."
  }
];

export const galleryData = [
  {
    id: 1,
    image: "https://i.ibb.co/V00cxY01/download.jpg",
    type: "Muscles",
    label: "Muscles",
    alt: "FIT-FRAME gym photoshoot"
  },
  {
    id: 2,
    image: "https://i.ibb.co/Ldg4BGz6/dsfsdfs.jpg",
    type: "Confidence",
    label: "Confidence",
    alt: "Professional fitness content"
  },
  {
    id: 3,
    image: "https://i.ibb.co/S4NWfLqh/focus.jpg",
    type: "Veins",
    label: "Veins",
    alt: "Transformation package shoot"
  },
  {
    id: 4,
    image: "https://i.ibb.co/RTRZhK7d/look-it.jpg",
    type: "Pose",
    label: "Pose",
    alt: "Gym professional photography"
  },
  {
    id: 5,
    image: "https://i.ibb.co/vvv0xsLg/jeet-click-0066.jpg",
    type: "Power",
    label: "Power",
    alt: "Cinematic gym reel"
  },
  {
    id: 6,
    image: "https://i.ibb.co/MvFfQR7/jeet-click-9922-3.jpg",
    type: "Sweat",
    label: "Sweat",
    alt: "Fitness photoshoot session"
  },
  {
    id: 7,
    image: "https://i.ibb.co/kgZGddf0/DSC0047-Edit.png",
    type: "Power",
    label: "Power",
    alt: "Professional gym content creation"
  },
  {
    id: 8,
    type: "Reel",
    label: "Reel",
    embedUrl: "https://www.instagram.com/reel/C_QXJSwtH0G/embed",
    alt: "Featured Instagram Reel"
  }
];

export const memberPlans = [
  {
    id: 1,
    name: "Starter",
    price: "1,499",
    originalPrice: "2,099",
    discount: "30% OFF",
    popular: false,
    includes: [
      "1 Reel",
      "2 High-Quality Photos",
      "Shoot at your gym",
      "Professional editing",
      "Delivery in 3-5 days"
    ]
  },
  {
    id: 2,
    name: "Pro",
    price: "2,199",
    originalPrice: "3,099",
    discount: "30% OFF",
    popular: true,
    includes: [
      "2 Reels",
      "5 High-Quality Photos",
      "Shoot at your gym",
      "Professional editing",
      "Priority delivery in 4-5 days",
      "Background music selection"
    ]
  },
  {
    id: 3,
    name: "Transformation Package",
    price: "4,999",
    originalPrice: "8,299",
    discount: "40% OFF",
    sessions: "2 sessions",
    popular: false,
    premium: true,
    includes: [
      "5 Reels",
      "15 High-Quality Photos",
      "Story-Based Guided Shoot",
      "Premium Editing",
      "2 shoot days",
      "Priority delivery in 4-5 days",
      "Custom music & effects"
    ]
  }
];

export const whyFitFrameData = [
  {
    id: 1,
    title: "We Come to Your Gym",
    description: "No studio trips needed. We shoot at your actual training space — authenticity is part of the product."
  },
  {
    id: 2,
    title: "Fitness-Focused Team",
    description: "We understand gym culture. We know how to capture form, intensity, and emotion — not just static poses."
  },
  {
    id: 3,
    title: "Scroll-Stopping Content",
    description: "Every reel and photo is crafted to perform on Instagram — designed for maximum engagement and reach."
  },
  {
    id: 4,
    title: "By Offline Capture",
    description: "Backed by Offline Capture — a professional content creation company based in Ahmedabad, Gujarat."
  }
];
